import { render, staticRenderFns } from "./NovoAssociado.vue?vue&type=template&id=7b5e66ad"
import script from "./NovoAssociado.vue?vue&type=script&lang=js"
export * from "./NovoAssociado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports